import { render } from "./FastMenu.vue?vue&type=template&id=4b4a82bb&scoped=true"
import script from "./FastMenu.vue?vue&type=script&lang=js"
export * from "./FastMenu.vue?vue&type=script&lang=js"

import "./FastMenu.vue?vue&type=style&index=0&id=4b4a82bb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4a82bb"]])

export default __exports__